/**
 * This file contains the Firebase configuration and initialization for the Simplicity project.
 * It sets up Firebase services including Firestore, Functions, Authentication, and Analytics.
 *
 * Author: Meng Li
 * Created on: 2024-11-01
 * Professor: Mejdi Eraslan
 * Client: Melisa Eraslan
 */

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// The web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBsS7G_yAjJo0CKRxSsS_yZ4TeoKNNDzIQ",
    authDomain: "simplicity-mne.firebaseapp.com",
    projectId: "simplicity-mne",
    storageBucket: "simplicity-mne.firebasestorage.app",
    messagingSenderId: "215466393455",
    appId: "1:215466393455:web:0d68ec326f8e8549f3729a",
    measurementId: "G-5T25TWXHE9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

export { db };

// Initialize Firebase Functions and get a reference to the service
const functions = getFunctions(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firebase Analytics and get a reference to the service
const analytics = getAnalytics(app);